import { render, staticRenderFns } from "./InviteUserModal.vue?vue&type=template&id=3fdef960&scoped=true&"
import script from "./InviteUserModal.vue?vue&type=script&lang=js&"
export * from "./InviteUserModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteUserModal.vue?vue&type=style&index=0&id=3fdef960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdef960",
  null
  
)

export default component.exports